import { Box, Skeleton, Stack } from "@mui/material";

function DocumentCardSkeleton({ large }: { large: boolean }) {
  if (!large) {
    return (
      <Skeleton
        variant="rounded"
        width={66}
        height={66}
        sx={{ borderRadius: 1 }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: 170,
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        overflow: "hidden",
        bgcolor: "#fff",
      }}
    >
      <Skeleton variant="rectangular" height={100} sx={{ borderRadius: "12px 12px 0 0" }} />
      <Box sx={{ p: 1.25 }}>
        <Skeleton variant="text" width="85%" height={18} />
        <Skeleton variant="text" width="60%" height={14} sx={{ mt: 0.5 }} />
        <Stack direction="row" spacing={0.5} sx={{ mt: 1 }}>
          <Skeleton variant="rounded" width={48} height={18} sx={{ borderRadius: 0.5 }} />
          <Skeleton variant="rounded" width={56} height={18} sx={{ borderRadius: 0.5 }} />
        </Stack>
      </Box>
    </Box>
  );
}

interface DocumentUploadSkeletonProps {
  viewType?: "small" | "large";
  count?: number;
}

export default function DocumentUploadSkeleton({
  viewType = "large",
  count,
}: DocumentUploadSkeletonProps) {
  const large = viewType === "large";
  const skeletonCount = count ?? (large ? 8 : 2);

  if (large) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: 1.5,
          alignItems: "stretch",
        }}
      >
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <DocumentCardSkeleton key={i} large />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
      {Array.from({ length: skeletonCount }).map((_, i) => (
        <DocumentCardSkeleton key={i} large={false} />
      ))}
    </Box>
  );
}
